import dayjs from "dayjs";

export const WEEKLY_REGULAR_DAYS = 5;

// Weekly pay for one employee row from the time-tracking list.
// The weekly regular limit is 5 × (shift − lunch), e.g. 7:00-3:00 with a 1h
// lunch is 5 × 7h = 35h. Weekday time up to the limit is regular; weekday
// time over it plus all weekend time is OT. Only approved OT is paid, and
// never more than the weekly OT.
export const calcWeeklyPay = (employee) => {
    const weeklyRegularLimit = WEEKLY_REGULAR_DAYS * Math.max(0, employee?.shift_minutes || 0);

    let weekdayMinutes = 0;
    let weekendMinutes = 0;
    let approvedOtMinutes = 0;

    employee?.timeTracking?.forEach(i => {
        const paidMinutes = (i?.regular_minutes || 0) + (i?.ot_time || 0);
        if ([0, 6].includes(dayjs(i?.date).day()))
            weekendMinutes += paidMinutes;
        else
            weekdayMinutes += paidMinutes;

        if (i?.is_ot_approved === 2)
            approvedOtMinutes += i?.approved_ot_time || 0;
    });

    const regularMinutes = Math.min(weekdayMinutes, weeklyRegularLimit);
    const otMinutes = Math.max(0, weekdayMinutes - weeklyRegularLimit) + weekendMinutes;
    const paidOtMinutes = Math.min(otMinutes, approvedOtMinutes);

    const regularWage = employee?.wage > 0 ? Math.round((regularMinutes / 60) * employee.wage) : 0;
    const otWage = employee?.ot_wage > 0 ? Math.round((paidOtMinutes / 60) * employee.ot_wage) : 0;

    return { regularMinutes, otMinutes, regularWage, otWage, wageTotal: regularWage + otWage };
}
